import { useEffect, useState } from 'react';

const useStickyHeader = (offset = 0) => {
    const [sticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => setSticky(window.scrollY > offset);
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [offset]);

    return sticky;
};

export default useStickyHeader;
